import { render, staticRenderFns } from "./TipeBisnisUnit.vue?vue&type=template&id=27803f1e&"
import script from "./TipeBisnisUnit.vue?vue&type=script&lang=js&"
export * from "./TipeBisnisUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports